export interface EntityWithDisplayIdentifier {
  key: string;
  identifier: string;
  distinguishedname?: string;
  displayName?: string;
  displayname?: string;
}

export function getDisplayIdentifierWithFallback(
  entity: EntityWithDisplayIdentifier,
  fallback: string
): string {
  if (!entity) {
    return fallback;
  }

  const displayNamePascal = entity.displayName?.trim();
  if (displayNamePascal) {
    return displayNamePascal;
  }

  const displayNameLower = entity.displayname?.trim();
  if (displayNameLower) {
    return displayNameLower;
  }

  const distinguishedName = entity.distinguishedname?.trim();
  if (distinguishedName) {
    return distinguishedName;
  }

  const identifier = entity.identifier?.trim();
  if (identifier) {
    return safeDecodeURIComponent(identifier);
  }

  return fallback; // Uses the explicit fallback parameter
}

/**
 * Safely decodes a URI component, returning the original string if decoding fails.
 * Handles cases like Azure DevOps repo names that contain %20 sequences.
 */
function safeDecodeURIComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
